import { Box, Button, Stack, Typography } from '@mui/material';
import { white } from '@styles/colors';
import { bold } from '@styles/fontWeights';
import { useContext, useEffect, useRef, useState } from 'react';
import SetStaffLevelsModal from './SetStaffLevelsModal';
import { authContext, Position } from '@staffedupusa/shared-components';
import { hasPermission } from '@features/profile/components/InviteUsersModal/PermissionUtils';
import { permissionsList } from '@features/profile/components/InviteUsersModal/constants';

function StaffLevelWarning({
  percent,
  localJobPostings,
}: {
  percent: number | null | undefined;
  localJobPostings: [] | Position[];
}) {
  const { authData } = useContext(authContext);
  const isAdminAccount = authData?.user?.master_account;
  const [isWrapped, setIsWrapped] = useState(false);
  const [showStaffLevelsModal, setShowStaffLevelsModal] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const getColor = () => {
    if (percent === null || percent === undefined || isNaN(percent))
      return 'error.main';
    if (percent === 0 || percent === Infinity) return 'error.main';
    if (percent > 0 && percent < 100) return 'yellow.main';
    return 'success.main';
  };

  const getStatusText = () => {
    if (percent === null || percent === undefined || isNaN(percent))
      return 'not set';
    if (percent === Infinity) {
      return 'not set';
    }
    return `${percent?.toFixed(0)}%`;
  };

  useEffect(() => {
    const checkWrap = () => {
      const el = wrapperRef.current;
      if (!el) return;
      const hasWrapped = el.scrollWidth > el.clientWidth;
      setIsWrapped(hasWrapped);
    };

    const observer = new ResizeObserver(checkWrap);
    if (wrapperRef.current) observer.observe(wrapperRef.current);
    checkWrap();

    return () => observer.disconnect();
  }, []);

  return (
    <Stack
      direction={isWrapped ? 'column' : { xs: 'column', xl: 'row' }}
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      p={3}
      spacing={3}
      bgcolor={white}
      borderRadius={8}
    >
      <Box
        ref={wrapperRef}
        sx={{
          display: 'inline-block',
          fontSize: '14px',
          fontWeight: bold,
          textAlign: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        <Typography
          component="span"
          variant="body1"
          sx={{ fontSize: '14px', fontWeight: bold }}
        >
          Staff Levels:{' '}
        </Typography>
        <Typography
          component="span"
          sx={{
            fontStyle: 'italic',
            color: getColor(),
            fontWeight: bold,
            fontSize: '14px',
          }}
        >
          {getStatusText()}
        </Typography>
      </Box>

      <Button
        onClick={() => setShowStaffLevelsModal(true)}
        variant="contained"
        size="small"
        sx={{ fontSize: '12px' }}
        disabled={
          !isAdminAccount &&
          !hasPermission(
            permissionsList.editPositions,
            //@ts-ignore
            //have to update user form private package
            authData.user?.permissions?.permissions,
          )
        }
      >
        Set Staff Levels
      </Button>
      {showStaffLevelsModal && (
        <SetStaffLevelsModal
          open={showStaffLevelsModal}
          handleClose={() => setShowStaffLevelsModal(false)}
          positions={localJobPostings}
        />
      )}
    </Stack>
  );
}

export default StaffLevelWarning;
